import { Check, Close } from "@mui/icons-material";
import React from "react";

// interface Props {
// 	value
// 	onChange: (res) => void;
// }
const PasswordStrength = (props) => {
    const { value } = props;

    const [valid, setValid] = React.useState({
        min: false,
        num: false,
        upp: false,
        symb: false,
    });

    React.useEffect(() => {
        setValid({
            min: (value || "").length >= 8 ? true : false,
            num: /\d/.test(value || ""),
            upp: /[A-Z]/.test(value || ""),
            symb: /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(value || ""),
        });
    }, [value]);

    React.useEffect(() => {
        props.onChange(Object.values(valid).filter((v) => !v).length === 0 ? true : false);
    }, [valid]);

    return (
        <React.Fragment>
            <CustomRadio selected={valid.upp} label="Lettre majuscule" />
            <CustomRadio selected={valid.num} label="Alphanumérique" />
            <CustomRadio selected={valid.symb} label="Caractère spécial" />
            <CustomRadio selected={valid.min} label="8 caractères" />

            <div style={{ clear: "both" }} />
        </React.Fragment>
    );
};

export default PasswordStrength;

const CustomRadio = ({ label, selected }) => {
    return (
        <React.Fragment>
            <div className={`flex items-center mb-1 font-primary ${selected ? "primary" : "danger"}`}>
                <div>{selected ? <Check style={{ height: 16 }} /> : <Close style={{ height: 16 }} />}</div>
                <span className="small">{label}</span>
            </div>
        </React.Fragment>
    );
};
